import { FormView } from '../account/form-view';
import { FirebaseDatabase } from "./firebase-database";
import firebase from "firebase/app";
import "firebase/auth";

export default FormView.extend({

    executeOperation: function() {
        let fullName = this.el.querySelector("#fullName");

        return new Promise((resolve, reject) => {

            let username = document.querySelector('.js-username');
            const chosenName = fullName.value.trim() || "";
            
            let gender = this.el.querySelector(".js-gender-radio:checked");
            const selectedGender = gender ? gender.value : null;
            
            const authUser = firebase.auth().currentUser;
            FirebaseDatabase.updateUserFullNameAndGender(authUser.uid, chosenName, selectedGender)
                .then(() => {
                    username.innerHTML = chosenName;
                    resolve();
                })
                .catch((error) => {
                    reject(getI18N(jlocale.error));
                });
        });
    }
})